// 旧 manage/js/app.js に置かれていたグローバルなオブジェクト
// ビルド・非ビルド共通で利用されているため一旦ここに置くが、将来的に整理する

var globalNotifyTimer = {};
window.globalNotifyTimer = globalNotifyTimer;

// 1時間の区切り分数
var _hourBy = 15;

// 勤怠管理用関数モジュール
var workHour = {
  interval: _hourBy,

  // 時間（小数点）から表示時刻（00:00）に変換
  hToHm: function (hour) {
    return this.mToHm(Math.trunc(hour * 60));
  },

  // 分から表示時刻（00:00）に変換
  mToHm: function (minutes) {
    return ('0' + Math.trunc(minutes / 60)).slice(-2) + ':' + ('0' + (minutes % 60)).slice(-2);
  },

  // 分から表示時刻（0時間00分）に変換
  mToHmJp: function (minutes) {
    return Math.trunc(minutes / 60) + '時間' + ('0' + (minutes % 60)).slice(-2) + '分';
  },

  // 拘束分数の算出
  getBindMinute: function (list, interval) {
    if (!list || list.start_time === 'undefined' || list.end_time === 'undefined') {
      return null;
    }

    var b = 0;
    var f = {
      start: this.timeCeil(list.start_time, interval),
      left: this.timeFloor(list.left_time, interval),
      bacq: this.timeCeil(list.back_time, interval),
      end: this.timeFloor(list.end_time, interval),
    };

    if (!f.start || !f.end) {
      return null;
    }

    var wt = new Date(+new Date('1970/01/01 ' + f.end) - +new Date('1970/01/01 ' + f.start));
    var wH = wt.getUTCHours();
    var wM = wt.getUTCMinutes();

    var wT = wH * 60 + wM;

    return wT;
  },

  // 拘束時間の算出
  getBindHour: function (list, interval) {
    if (!list || list.start_time === 'undefined' || list.end_time === 'undefined') {
      return null;
    }

    var b = 0;
    var f = {
      start: this.timeCeil(list.start_time, interval),
      left: this.timeFloor(list.left_time, interval),
      bacq: this.timeCeil(list.back_time, interval),
      end: this.timeFloor(list.end_time, interval),
    };

    if (!f.start || !f.end) {
      return null;
    }

    var wt = new Date(+new Date('1970/01/01 ' + f.end) - +new Date('1970/01/01 ' + f.start));
    var wH = wt.getUTCHours();
    var wM = wt.getUTCMinutes() / 60;

    var wT = wH + wM;

    return wT;
  },

  // 就業分数の算出
  getWorkMinute: function (list, interval) {
    if (!list || list.start_time === 'undefined' || list.end_time === 'undefined') {
      return null;
    }

    var b = 0;
    var f = {
      start: this.timeCeil(list.start_time, interval),
      left: this.timeFloor(list.left_time, interval),
      bacq: this.timeCeil(list.back_time, interval),
      end: this.timeFloor(list.end_time, interval),
    };

    if (!f.start || !f.end) {
      return null;
    }

    var wt = new Date(+new Date('1970/01/01 ' + f.end) - +new Date('1970/01/01 ' + f.start));
    var wH = wt.getUTCHours();
    var wM = wt.getUTCMinutes();

    var wT = wH * 60 + wM;

    if (f.left && f.bacq && f.left < f.bacq) {
      var bt = new Date(+new Date('1970/01/01 ' + f.bacq) - +new Date('1970/01/01 ' + f.left));
      var bH = bt.getUTCHours();
      var bM = bt.getUTCMinutes();
      b = bH * 60 + bM;
    }

    return wT - b;
  },

  // 就業時間の算出
  getWorkHour: function (list, interval) {
    if (!list || list.start_time === 'undefined' || list.end_time === 'undefined') {
      return null;
    }

    var b = 0;
    var f = {
      start: this.timeCeil(list.start_time, interval),
      left: this.timeFloor(list.left_time, interval),
      bacq: this.timeCeil(list.back_time, interval),
      end: this.timeFloor(list.end_time, interval),
    };

    if (!f.start || !f.end) {
      return null;
    }

    var wt = new Date(+new Date('1970/01/01 ' + f.end) - +new Date('1970/01/01 ' + f.start));
    var wH = wt.getUTCHours();
    var wM = wt.getUTCMinutes() / 60;

    var wT = wH + wM;

    if (f.left && f.bacq && f.left < f.bacq) {
      var bt = new Date(+new Date('1970/01/01 ' + f.bacq) - +new Date('1970/01/01 ' + f.left));
      var bH = bt.getUTCHours();
      var bM = bt.getUTCMinutes() / 60;
      b = bH + bM;
    }

    return wT - b;
  },

  // 休憩分数の算出
  getRestMinute: function (list, interval) {
    if (!list || list.start_time === 'undefined' || list.end_time === 'undefined') {
      return null;
    }

    var b = 0;
    var f = {
      start: this.timeCeil(list.start_time, interval),
      left: this.timeFloor(list.left_time, interval),
      bacq: this.timeCeil(list.back_time, interval),
      end: this.timeFloor(list.end_time, interval),
    };

    if (!f.left || !f.bacq) {
      return null;
    }

    // left_timeがback_timeよりあとの場合不正扱い
    if (f.left > f.bacq) {
      return null;
    }

    var wt = new Date(+new Date('1970/01/01 ' + f.bacq) - +new Date('1970/01/01 ' + f.left));
    var wH = wt.getUTCHours();
    var wM = wt.getUTCMinutes();

    return wH * 60 + wM;
  },

  // 休憩時間の算出
  getRestHour: function (list, interval) {
    if (!list || list.start_time === 'undefined' || list.end_time === 'undefined') {
      return null;
    }

    var b = 0;
    var f = {
      start: this.timeCeil(list.start_time, interval),
      left: this.timeFloor(list.left_time, interval),
      bacq: this.timeCeil(list.back_time, interval),
      end: this.timeFloor(list.end_time, interval),
    };

    if (!f.left || !f.bacq) {
      return null;
    }

    // left_timeがback_timeよりあとの場合不正扱い
    if (f.left > f.bacq) {
      return null;
    }

    var wt = new Date(+new Date('1970/01/01 ' + f.bacq) - +new Date('1970/01/01 ' + f.left));
    var wH = wt.getUTCHours();
    var wM = wt.getUTCMinutes() / 60;

    return wH + wM;
  },

  // 時間外労働分数の算出
  overMinute: function (minute) {
    if (!minute) {
      return minute;
    }

    return minute > 60 * 8 ? minute - 60 * 8 : null;
  },

  // 時間外労働時間の算出
  overHour: function (hour) {
    if (!hour) {
      return null;
    }

    return hour > 8 ? hour - 8 : null;
  },

  // 時刻の切り上げ(interval分で)
  timeCeil: function (_time, interval) {
    if (!interval) {
      // デフォルト
      interval = this.interval;
    }

    if (!_time) {
      return null;
    }
    var t = new Date(_time);
    var p = interval * 60 * 1000;
    t.getMinutes() % interval != 0 && t.setTime(Math.ceil(t.getTime() / p) * p);

    return ('0' + t.getHours()).slice(-2) + ':' + ('0' + t.getMinutes()).slice(-2);
  },

  // 時刻の切り捨て(interval分で)
  timeFloor: function (_time, interval) {
    if (!interval) {
      // デフォルト
      interval = this.interval;
    }

    if (!_time) {
      return null;
    }
    var t = new Date(_time);
    var p = interval * 60 * 1000;
    t.getMinutes() % interval != 0 && t.setTime(Math.floor(t.getTime() / p) * p);

    return ('0' + t.getHours()).slice(-2) + ':' + ('0' + t.getMinutes()).slice(-2);
  },

  // 深夜勤務分数の算出(22時から翌5時)
  midnightMinute: function (list, interval) {
    if (!interval) {
      // デフォルト
      interval = this.interval;
    }

    var lb = 0;
    var s = this.timeCeil(list.start_time, interval);
    var l = this.timeFloor(list.left_time, interval);
    var b = this.timeCeil(list.back_time, interval);
    var e = this.timeFloor(list.end_time, interval);

    var sHM = angular.isString(s) && s.split(':');
    var eHM = angular.isString(e) && e.split(':');
    var lHM = angular.isString(l) && l.split(':');
    var bHM = angular.isString(b) && b.split(':');

    var _s = new Date(list.start_time);
    var _e = new Date(list.end_time);
    _s.setHours(sHM[0]), _e.setHours(eHM[0]), _e.getHours() < _s.getHours() && _e.setDate(_e.getDate() + 1);
    _s.setMinutes(sHM[1]), _e.setMinutes(eHM[1]);
    _s.setSeconds(0), _e.setSeconds(0);
    _s.setMilliseconds(0), _e.setMilliseconds(0);

    var _l = new Date(list.left_time);
    var _b = new Date(list.back_time);
    _l.setHours(lHM[0]), _b.setHours(bHM[0]), _b.getHours() < _l.getHours() && _b.setDate(_b.getDate() + 1);
    _l.setMinutes(lHM[1]), _b.setMinutes(bHM[1]);
    _l.setSeconds(0), _b.setSeconds(0);
    _l.setMilliseconds(0), _b.setMilliseconds(0);

    var _mStart = new Date();
    _mStart.setHours(22), _mStart.setMinutes(0), _mStart.setSeconds(0), _mStart.setMilliseconds(0);

    var _mEnd = new Date();
    _mEnd.setDate(_mEnd.getDate() + 1),
      _mEnd.setHours(5),
      _mEnd.setMinutes(0),
      _mEnd.setSeconds(0),
      _mEnd.setMilliseconds(0);

    var midStart = Math.max(_s, _mStart);
    var midEnd = Math.min(_e, _mEnd);

    if (_e >= _mStart && _s <= _mEnd) {
      var midHour = new Date(+new Date(midEnd) - +new Date(midStart));
      var mH = midHour.getUTCHours(),
        mM = midHour.getUTCMinutes();

      if (l && b) {
        if (_l >= _mStart) {
          if (_b > _mEnd) {
            _b = _mEnd;
          }
          var bt = new Date(_b - _l);
          var bH = bt.getUTCHours();
          var bM = bt.getUTCMinutes();
          lb = bH * 60 + bM;
        }
      }

      return Math.abs(mH * 60 + mM - lb);
    } else {
      return null;
    }
  },

  // 深夜勤務時間の算出(22時から翌5時)
  midnightHour: function (list, interval) {
    if (!interval) {
      // デフォルト
      interval = this.interval;
    }

    var lb = 0;
    var s = this.timeCeil(list.start_time, interval);
    var l = this.timeFloor(list.left_time, interval);
    var b = this.timeCeil(list.back_time, interval);
    var e = this.timeFloor(list.end_time, interval);

    var sHM = angular.isString(s) && s.split(':');
    var eHM = angular.isString(e) && e.split(':');
    var lHM = angular.isString(l) && l.split(':');
    var bHM = angular.isString(b) && b.split(':');

    var _s = new Date(list.start_time);
    var _e = new Date(list.end_time);
    _s.setHours(sHM[0]), _e.setHours(eHM[0]), _e.getHours() < _s.getHours() && _e.setDate(_e.getDate() + 1);
    _s.setMinutes(sHM[1]), _e.setMinutes(eHM[1]);
    _s.setSeconds(0), _e.setSeconds(0);
    _s.setMilliseconds(0), _e.setMilliseconds(0);

    var _l = new Date(list.left_time);
    var _b = new Date(list.back_time);
    _l.setHours(lHM[0]), _b.setHours(bHM[0]), _b.getHours() < _l.getHours() && _b.setDate(_b.getDate() + 1);
    _l.setMinutes(lHM[1]), _b.setMinutes(bHM[1]);
    _l.setSeconds(0), _b.setSeconds(0);
    _l.setMilliseconds(0), _b.setMilliseconds(0);

    var _mStart = new Date();
    _mStart.setHours(22), _mStart.setMinutes(0), _mStart.setSeconds(0), _mStart.setMilliseconds(0);

    var _mEnd = new Date();
    _mEnd.setDate(_mEnd.getDate() + 1),
      _mEnd.setHours(5),
      _mEnd.setMinutes(0),
      _mEnd.setSeconds(0),
      _mEnd.setMilliseconds(0);

    var midStart = Math.max(_s, _mStart);
    var midEnd = Math.min(_e, _mEnd);

    if (_e >= _mStart && _s <= _mEnd) {
      var midHour = new Date(+new Date(midEnd) - +new Date(midStart));
      var mH = midHour.getUTCHours(),
        mM = midHour.getUTCMinutes() / 60;

      if (l && b) {
        if (_l >= _mStart) {
          if (_b > _mEnd) {
            _b = _mEnd;
          }
          var bt = new Date(_b - _l);
          var bH = bt.getUTCHours();
          var bM = bt.getUTCMinutes() / 60;
          lb = bH + bM;
        }
      }

      return Math.abs(mH + mM - lb).toFixed(2);
    } else {
      return null;
    }
  },
};
window.workHour = workHour;

// 日付・カレンダー関連の関数モジュール
var cal = {
  dn: ['日', '月', '火', '水', '木', '金', '土'],
  fy: [4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3],

  dayName: function (dt) {
    // 引数dtの曜日を算出
    var _d = dt ? new Date(dt) : new Date();
    return this.dn[_d.getDay()];
  },

  dayNames: function (ym) {
    // 引数ym(年月)1か月の日付と曜日を配列で戻します。Dateでインスタンスができれば引数の形は問いません。
    var l = this.dayOfMonth(ym);
    var _d = ym ? new Date(ym) : new Date();
    var ret = [];

    for (var i = 1; i <= l; i++) {
      _d.setDate(i);
      ret[i] = this.dayName(_d);
    }

    return ret;
  },

  dayOfMonth: function (ym) {
    // 引数ym(年月)の末日を算出します。Dateでインスタンスができれば引数の形は問いません。
    var _d = ym ? new Date(ym) : new Date();
    _d.setMonth(_d.getMonth() + 1);
    _d.setDate(0);
    return _d.getDate();
  },

  prevWeeks: function (ym, week, f) {
    // week週前の、1週間の開始と終了日を返す。
    var _df = ym ? new Date(ym) : new Date();

    var _f = f || 1;
    var _dl = new Date(_df.setDate(_f));
    _df.setDate(-(week * 7) + 1);
    _dl.setDate(_dl.getDate() - 1);

    return {
      first: _df,
      last: _dl,
    };
  },

  followWeeks: function (ym, week, f) {
    // week週後の、1週間の開始と終了日を返す。
    var _df = ym ? new Date(ym) : new Date();

    var _f = f || 1;
    var _dl = new Date(_df.setDate(_f));
    _dl.setDate(_df.getDate() + week * 7);

    return {
      first: _df,
      last: _dl,
    };
  },

  fiscalYear: function (ym) {
    // 引数ym(年月日)の年度を返す。
    var _d = ym ? new Date(ym) : new Date();
    var month = _d.getMonth();
    var ret = _d.getFullYear();

    return month > -1 && month < 3 ? ret - 1 : ret;
  },

  fiscalMonths: function (ym) {
    var _d = ym ? new Date(ym) : new Date();
    return this.fy.map(function (m, index) {
      var thisYear = index > 8 ? _d.getFullYear() + 1 : _d.getFullYear();
      return new Date(thisYear + '/' + m + '/' + '01');
    });
  },

  yearsOld: function (birthday, date) {
    // 引数birthdayの誕生日の、dateの日付の年度年齢(4/1時点の年齢)を返す。
    // なお、４月１日生まれも早生まれに入るよう考慮されている
    var _date = date ? new Date(date) : new Date();
    _date = new Date(_date.getFullYear(), _date.getMonth(), _date.getDate(), 0, 0, 0);

    var _birthday = new Date(birthday);
    _birthday = new Date(_birthday.getFullYear(), _birthday.getMonth(), _birthday.getDate(), 0, 0, 0);

    var _year = this.fiscalYear(_date);
    var standardDate = new Date(_year + '/04/01');

    // 対象年度と誕生日の年の差
    var yearsOld = standardDate.getFullYear() - _birthday.getFullYear() - 1;

    // 1月1日生まれ 〜 4月1日生まれ は早生まれで、年が一つ増える
    if (_birthday.getMonth() < 3) {
      yearsOld++;
    } else if (_birthday.getMonth() == 3 && _birthday.getDate() == 1) {
      // 4月1日生まれも早生まれ
      yearsOld++;
    }

    // 基準日の時点でまだ生まれてない場合
    // TODO: 「対象年度と誕生日の年の差」の計算処理で-1以下になる可能性もあるので、その場合も0にする？
    if (yearsOld == -1) {
      yearsOld = 0;
    }

    return yearsOld;
  },
};
window.cal = cal;
